"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderPredicates = exports.composedFromIdentifier = exports.composedFromUri = exports.objMatch = exports.objRefMatch = exports.localIdentifierMatch = exports.attributeItemNameMatch = exports.identifierMatch = exports.uriMatch = void 0;
var MappingHeader_1 = require("./MappingHeader");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_model_1 = require("@gooddata/sdk-model");
/**
 * This predicate is returned when predicate factory encounters invalid input. Having it to keep backward
 * compatibility with the previous more lenient behavior.
 */
var alwaysFalsePredicate = function () { return false; };
function arithmeticMeasureLocalIdentifierDeepMatch(dv, operandLocalIdentifier, predicate, context) {
    var operand = dv.def().measure(operandLocalIdentifier);
    var operandDescriptor = dv.meta().measureDescriptor(operandLocalIdentifier);
    if (sdk_model_1.isArithmeticMeasure(operand)) {
        var operands = sdk_model_1.measureArithmeticOperands(operand);
        return (operands ? operands : []).some(function (operandLocalIdentifier) {
            return arithmeticMeasureLocalIdentifierDeepMatch(dv, operandLocalIdentifier, predicate, context);
        });
    }
    return predicate(operandDescriptor, context);
}
function getMasterMeasureOperandIdentifiers(measure) {
    return sdk_model_1.measureArithmeticOperands(measure);
}
function getDerivedMeasureMasterMeasureOperandIdentifiers(measure, dv) {
    var masterMeasureLocalIdentifier = sdk_model_1.measureMasterIdentifier(measure);
    if (!masterMeasureLocalIdentifier) {
        return null;
    }
    var masterMeasure = dv.def().measure(masterMeasureLocalIdentifier);
    var result = getMasterMeasureOperandIdentifiers(masterMeasure);
    if (result === undefined) {
        return null;
    }
    return result;
}
function composedFromQualifier(predicate) {
    return function (header, context) {
        if (!sdk_backend_spi_1.isMeasureDescriptor(header)) {
            return false;
        }
        var dv = context.dv;
        var measureLocalIdentifier = MappingHeader_1.getMappingHeaderLocalIdentifier(header);
        var measure = dv.def().measure(measureLocalIdentifier);
        if (!measure) {
            return false;
        }
        var arithmeticMeasureOperands = getDerivedMeasureMasterMeasureOperandIdentifiers(measure, dv) ||
            getMasterMeasureOperandIdentifiers(measure);
        if (!arithmeticMeasureOperands) {
            return false;
        }
        return arithmeticMeasureOperands.some(function (operandLocalIdentifier) {
            return arithmeticMeasureLocalIdentifierDeepMatch(dv, operandLocalIdentifier, predicate, context);
        });
    };
}
function matchHeaderUri(uri, header) {
    var headerUri = MappingHeader_1.getMappingHeaderUri(header);
    return headerUri ? headerUri === uri : false;
}
function matchHeaderIdentifier(identifier, header) {
    var headerIdentifier = MappingHeader_1.getMappingHeaderIdentifier(header);
    return headerIdentifier ? headerIdentifier === identifier : false;
}
function matchUri(uri, measure) {
    var simpleMeasureUri = sdk_model_1.measureUri(measure);
    return simpleMeasureUri ? simpleMeasureUri === uri : false;
}
function matchMeasureIdentifier(identifier, measure) {
    var simpleMeasureIdentifier = sdk_model_1.measureIdentifier(measure);
    return simpleMeasureIdentifier ? simpleMeasureIdentifier === identifier : false;
}
function matchDerivedMeasureByMasterUri(uri, measure, context) {
    var dv = context.dv;
    var masterMeasureLocalIdentifier = sdk_model_1.measureMasterIdentifier(measure);
    if (masterMeasureLocalIdentifier === undefined) {
        return false;
    }
    var masterMeasureHeader = dv.meta().measureDescriptor(masterMeasureLocalIdentifier);
    if (matchHeaderUri(uri, masterMeasureHeader)) {
        return true;
    }
    var masterMeasure = dv.def().measure(masterMeasureLocalIdentifier);
    return matchUri(uri, masterMeasure);
}
function matchDerivedMeasureByMasterIdentifier(identifier, measure, context) {
    var dv = context.dv;
    var masterMeasureLocalIdentifier = sdk_model_1.measureMasterIdentifier(measure);
    if (masterMeasureLocalIdentifier === undefined) {
        return false;
    }
    var masterMeasureHeader = dv.meta().measureDescriptor(masterMeasureLocalIdentifier);
    if (matchHeaderIdentifier(identifier, masterMeasureHeader)) {
        return true;
    }
    var masterMeasure = dv.def().measure(masterMeasureLocalIdentifier);
    return matchMeasureIdentifier(identifier, masterMeasure);
}
/**
 * Creates a new predicate that returns true for any header that belongs to either attribute or measure with the
 * provided URI.
 *
 * @public
 */
function uriMatch(uri) {
    if (!uri) {
        return alwaysFalsePredicate;
    }
    return function (header, context) {
        var dv = context.dv;
        if (matchHeaderUri(uri, header)) {
            return true;
        }
        if (!sdk_backend_spi_1.isMeasureDescriptor(header)) {
            return false;
        }
        var measure = dv.def().measure(MappingHeader_1.getMappingHeaderLocalIdentifier(header));
        if (!measure) {
            return false;
        }
        if (matchUri(uri, measure)) {
            return true;
        }
        return matchDerivedMeasureByMasterUri(uri, measure, context);
    };
}
exports.uriMatch = uriMatch;
/**
 * Creates a new predicate that returns true for any header that belongs to either attribute or measure with the
 * provided identifier.
 *
 * @public
 */
function identifierMatch(identifier) {
    if (!identifier) {
        return alwaysFalsePredicate;
    }
    return function (header, context) {
        var dv = context.dv;
        if (sdk_backend_spi_1.isResultAttributeHeader(header)) {
            return false;
        }
        if (matchHeaderIdentifier(identifier, header)) {
            return true;
        }
        if (!sdk_backend_spi_1.isMeasureDescriptor(header)) {
            return false;
        }
        var measure = dv.def().measure(MappingHeader_1.getMappingHeaderLocalIdentifier(header));
        if (!measure) {
            return false;
        }
        if (matchMeasureIdentifier(identifier, measure)) {
            return true;
        }
        return matchDerivedMeasureByMasterIdentifier(identifier, measure, context);
    };
}
exports.identifierMatch = identifierMatch;
/**
 * Creates a predicate that return true for any attribute result header with the provided name.
 *
 * @public
 */
function attributeItemNameMatch(name) {
    if (!name) {
        return alwaysFalsePredicate;
    }
    return function (header, _context) {
        return sdk_backend_spi_1.isResultAttributeHeader(header)
            ? header.attributeHeaderItem && header.attributeHeaderItem.name === name
            : false;
    };
}
exports.attributeItemNameMatch = attributeItemNameMatch;
/**
 * Creates a new predicate that returns true for any header that belongs to either attribute or measure with the
 * provided local identifier.
 *
 * @public
 */
function localIdentifierMatch(localIdOrMeasure) {
    if (!localIdOrMeasure) {
        return alwaysFalsePredicate;
    }
    var localId = typeof localIdOrMeasure === "string" ? localIdOrMeasure : sdk_model_1.measureLocalId(localIdOrMeasure);
    return function (header, _context) {
        if (!MappingHeader_1.hasMappingHeaderLocalIdentifier(header)) {
            return false;
        }
        var headerLocalIdentifier = MappingHeader_1.getMappingHeaderLocalIdentifier(header);
        return headerLocalIdentifier !== undefined && headerLocalIdentifier === localId;
    };
}
exports.localIdentifierMatch = localIdentifierMatch;
/**
 * Creates a new predicate that returns true for any header that belongs to either attribute or measure with the
 * provided object reference.
 *
 * @public
 */
function objRefMatch(objRef) {
    return sdk_model_1.isIdentifierRef(objRef)
        ? exports.HeaderPredicates.identifierMatch(objRef.identifier)
        : exports.HeaderPredicates.uriMatch(objRef.uri);
}
exports.objRefMatch = objRefMatch;
/**
 * Creates a new predicate that returns true for any header that belongs to either attribute or measure matching
 * the provided object.
 *
 * If the object is empty or is not attribute, simple measure or object reference, the function returns predicate
 * that is always falsy.
 *
 * @param obj - the object to be checked
 *
 * @public
 */
function objMatch(obj) {
    if (!obj) {
        return alwaysFalsePredicate;
    }
    if (sdk_model_1.isAttribute(obj)) {
        return function (header, context) {
            return localIdentifierMatch(sdk_model_1.attributeLocalId(obj))(header, context) ||
                objRefMatch(sdk_model_1.attributeDisplayFormRef(obj))(header, context);
        };
    }
    if (sdk_model_1.isSimpleMeasure(obj)) {
        return function (header, context) {
            return localIdentifierMatch(sdk_model_1.measureLocalId(obj))(header, context) ||
                objRefMatch(sdk_model_1.measureItem(obj))(header, context);
        };
    }
    if (sdk_model_1.isObjRef(obj)) {
        return objRefMatch(obj);
    }
    return alwaysFalsePredicate;
}
exports.objMatch = objMatch;
/**
 * Creates a new predicate that returns true of any arithmetic measure where measure with the provided URI
 * is used as an operand.
 *
 * @public
 */
function composedFromUri(uri) {
    if (!uri) {
        return alwaysFalsePredicate;
    }
    return composedFromQualifier(uriMatch(uri));
}
exports.composedFromUri = composedFromUri;
/**
 * Creates a new predicate that returns true of any arithmetic measure where measure with the provided identifier
 * is used as an operand.
 *
 * @public
 */
function composedFromIdentifier(identifier) {
    if (!identifier) {
        return alwaysFalsePredicate;
    }
    return composedFromQualifier(identifierMatch(identifier));
}
exports.composedFromIdentifier = composedFromIdentifier;
/**
 * Set of factory functions to create the most commonly-used {@link IHeaderPredicate | HeaderPredicates}.
 *
 * @public
 */
exports.HeaderPredicates = {
    attributeItemNameMatch: attributeItemNameMatch,
    composedFromIdentifier: composedFromIdentifier,
    composedFromUri: composedFromUri,
    identifierMatch: identifierMatch,
    localIdentifierMatch: localIdentifierMatch,
    uriMatch: uriMatch,
    objRefMatch: objRefMatch,
    objMatch: objMatch,
};
//# sourceMappingURL=HeaderPredicateFactory.js.map